/* POWNYM Critical Render Path Optimization */

// Preload LCP image — find the largest visible image and preload it
(function() {
  // Find hero/LCP image
  var heroImg = document.querySelector('.m-hero__bg img, .m-slideshow__bg img, .m-banner__bg img, .m-hero img');
  if (heroImg && heroImg.src) {
    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = heroImg.src;
    if (heroImg.srcset) {
      link.imagesrcset = heroImg.srcset;
    }
    if (!document.querySelector('link[rel="preload"][href="' + heroImg.src + '"]')) {
      document.head.appendChild(link);
    }
  }
  
  // Lazy load below-fold images
  if ('IntersectionObserver' in window) {
    var lazyImages = document.querySelectorAll('img:not([loading])');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          img.loading = 'lazy';
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    
    // Only lazy-load images that are NOT in the hero/LCP area
    lazyImages.forEach(function(img) {
      var parent = img.closest('.m-hero, .m-hero__bg, .m-slideshow, .m-banner, .m-header');
      if (!parent) {
        img.loading = 'lazy';
      }
    });
  }
  
  // Optimize INP — defer non-critical event handlers
  document.addEventListener('DOMContentLoaded', function() {
    // Remove hover animations on mobile to improve INP
    if (window.innerWidth <= 768) {
      document.querySelectorAll('[data-animation]').forEach(function(el) {
        el.removeAttribute('data-animation');
      });
    }
  });
})();


/* POWNYM LCP Optimization */
(function() {
  // Force video to start playing as soon as possible
  function initHeroVideo() {
    var videos = document.querySelectorAll('.pownym-video-hero__video');
    videos.forEach(function(video) {
      if (video.readyState === 0) {
        video.load();
      }
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function() {
          // Autoplay was prevented, try muted
          video.muted = true;
          video.play().catch(function() {});
        });
      }
    });
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState !== 'loading') {
    initHeroVideo();
  } else {
    document.addEventListener('DOMContentLoaded', initHeroVideo);
  }

  // Report LCP metric to console for debugging
  if (window.PerformanceObserver) {
    try {
      var po = new PerformanceObserver(function(entryList) {
        var entries = entryList.getEntries();
        var lastEntry = entries[entries.length - 1];
        console.log('[LCP]', lastEntry.startTime, 'ms', lastEntry.element ? lastEntry.element.tagName : 'unknown');
      });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch(e) {}
  }
})();
